import { useEffect, useState } from "react";
import * as S from "./style";
import LayoutDetails from "../../../../components/LayoutModal/LayoutDetails";
import ImgGlasse from "../../../../assets/glasses.jpg";
import axiosInstance from "services/axiosInstance";
import Loading from "../../../../components/Loading";
import { CurrencyFormat, formatPercentage } from "utils/CurrencyFormat";
import ActionButton from "../../../../components/Button/ActionButton";
import BarcodeExport from "../../../../components/Barcode";
//Icons
import { Barcode } from "@phosphor-icons/react";
//hooks
import { useMultipleModal } from "../../../../hooks/useMultipleModal";
import useLoading from "../../../../hooks/useLoading";
//Interface
import { IFrame } from "Interfaces/IFrame";
// utils
import FormatarData from "utils/FormatData";

interface IDetails {
  isOpenModalDetails: boolean;
  setModalClose: () => void;
  selectedUrlId: number | null;
}

export default function Details({
  isOpenModalDetails,
  setModalClose,
  selectedUrlId,
}: IDetails) {

  const [data, setData] = useState<IFrame | null>(null);
  const { isLoading, startLoading, stopLoading } = useLoading();
  const { isOpenModal, toggleModalVisibility } = useMultipleModal();

  useEffect(() => {
    const fetchData = async () => {
      startLoading();
      try {
        const response = await axiosInstance.get(`frame/${selectedUrlId}`);
        setData(response.data);
      } catch (error) {
        console.log("Error: ", error);
      } finally {
        stopLoading();
      }
    };
    if (selectedUrlId !== null) {
      fetchData();
    }
  }, [selectedUrlId]);

  if (isOpenModalDetails) {
    return (
      <LayoutDetails
        title="Detalhes da Armação"
        subTitle="Veja todos os detalhes disponíveis sobre a armação."
        setModalClose={setModalClose}
      >
        {isLoading || !data ? ( // Se estiver carregando ou os dados forem nulos, mostra o loading
          <Loading />
        ) : (
          <S.Content>
            <S.Header>
              <S.ContentImage>
                <S.Image src={ImgGlasse} alt="Imagem Óculos" />
              </S.ContentImage>

              <S.ContentInfor>
                <S.Infor>
                  <p>Código da Armação:</p>
                  <span>{data.code || "-"}</span>
                </S.Infor>
                <S.Infor>
                  <p>Código de barra:</p>
                  <span>{data.barcode || "-"}</span>
                </S.Infor>
                <S.Infor>
                  <p>Preço:</p>
                  <span>
                    {CurrencyFormat(parseFloat(data.price || "0"))}
                  </span>
                </S.Infor>
              </S.ContentInfor>
            </S.Header>

            <S.Body>
              <S.Section>
                <S.ContentBody>
                  <S.InforBody>
                    <p>Cor</p>
                    <span>{data.color || "-"}</span>
                  </S.InforBody>

                  <S.InforBody>
                    <p>Ponte</p>
                    <span>{data.bridge || "-"}</span>
                  </S.InforBody>

                  <S.InforBody>
                    <p>Fornecedor</p>
                    <span>{data.suppliers?.name || "-"}</span>
                  </S.InforBody>
                </S.ContentBody>

                <S.ContentBody>
                  <S.InforBody>
                    <p>Tamanho</p>
                    <span>{data.size || "-"}</span>
                  </S.InforBody>

                  <S.InforBody>
                    <p>Tipo de Armação</p>
                    <span>{data.materials?.material || "-"}</span>
                  </S.InforBody>
                </S.ContentBody>

                <S.ContentBody>
                  <S.InforBody>
                    <p>Haste</p>
                    <span>{data.haste || "-"}</span>
                  </S.InforBody>

                  <S.InforBody>
                    <p>Grife</p>
                    <span>{data.brands?.brand || "-"}</span>
                  </S.InforBody>
                </S.ContentBody>
              </S.Section>

              <S.FeaturedSection>
                <S.ContentBody>
                  <S.InforBody>
                    <p>Valor de Compra</p>
                    <span>
                      {CurrencyFormat(parseFloat(data.purchase_value || "0"))}
                    </span>
                  </S.InforBody>

                  <S.InforBody>
                    <p>Quantidade</p>
                    <span>{data.amount || "0"} und.</span>
                  </S.InforBody>
                </S.ContentBody>

                <S.ContentBody>
                  <S.InforBody>
                    <p>Lucro</p>
                    <span>{formatPercentage(parseFloat(data.profit) || 0)}%</span>
                  </S.InforBody>

                  <S.InforBody>
                    <p>Desconto da Grife</p>
                    <span>{data.brands?.discount || "0"}%</span>
                  </S.InforBody>
                </S.ContentBody>

                <S.ContentBody>
                  <S.InforBody>
                    <p>Valor da Venda</p>
                    <span>
                      {CurrencyFormat(parseFloat(data.price || "0"))}
                    </span>
                  </S.InforBody>
                </S.ContentBody>
              </S.FeaturedSection>

              <S.InforBody>
                <p>Descrição</p>
                <S.Description>{data.description || "-"}</S.Description>
              </S.InforBody>

              <S.InforBody>
                  <S.InforSmall>Cadastrado em: {FormatarData(data.created_at || "-")}</S.InforSmall>
                  <S.InforSmall>Ultima atualização em: {FormatarData(data.updated_at) || "-"}</S.InforSmall>
              </S.InforBody>

              <S.ContentButton>
                <ActionButton
                  Icon={<Barcode size={32} />}
                  onClick={() => toggleModalVisibility("barcode")}
                />
              </S.ContentButton>
            </S.Body>

            <BarcodeExport
              barcode={data.barcode}
              name={data.code}
              brands={data.brands?.brand}
              price={data.price}
              isOpenBarcode={isOpenModal("barcode")}
              setModalClose={() => toggleModalVisibility("barcode")}
            />
          </S.Content>
        )}
      </LayoutDetails>
    );
  }
  return null;
}
